import styled from 'styled-components'

export const Container = styled.div`
  margin-top: 2px;
  background-color: #EBECF0;
  position: absolute;
  z-index: 1;
`

export const Title = styled.div`
  color: #172B4D;
  padding: 1rem;
`

export const MachineList = styled.ul`
  list-style: none;
`

export const MachineItem= styled.li`
  padding: .5rem 1rem;
  cursor: pointer;
  :hover {
    background-color:rgb(211, 211, 211);
  }
`